import * as en from '@webapp/i18n/langs/en.json';
import * as de from '@webapp/i18n/langs/de.json';
import * as ru from '@webapp/i18n/langs/ru.json';
import * as es from '@webapp/i18n/langs/es.json';
import * as it from '@webapp/i18n/langs/it.json';
import * as fr from '@webapp/i18n/langs/fr.json';
import * as pt from '@webapp/i18n/langs/pt.json';
import * as cs from '@webapp/i18n/langs/cs.json';
import { onboardingMessages } from './onboarding';
import { aiServicesMessages } from './aiServices';
import { professionDescriptions } from './professionDescriptions';

const deepMerge = (target, source) => {
    const result = { ...target };
    for (const key of Object.keys(source)) {
        if (result[key] && typeof result[key] === 'object' && typeof source[key] === 'object' && !Array.isArray(source[key])) {
            result[key] = deepMerge(result[key], source[key]);
        } else {
            result[key] = source[key];
        }
    }
    return result;
};

const merge = (...sources) => sources.reduce((acc, src) => src ? deepMerge(acc, src) : acc, {});

export const messages = {
    en: merge(en, onboardingMessages.en, aiServicesMessages.en, professionDescriptions.en),
    de: merge(de, onboardingMessages.de, aiServicesMessages.de, professionDescriptions.de),
    ru: merge(ru, onboardingMessages.ru, aiServicesMessages.ru, professionDescriptions.ru),
    es: merge(es, onboardingMessages.es, aiServicesMessages.es, professionDescriptions.es),
    it: merge(it, onboardingMessages.it, aiServicesMessages.it, professionDescriptions.it),
    fr: merge(fr, onboardingMessages.fr, aiServicesMessages.fr, professionDescriptions.fr),
    pt: merge(pt, onboardingMessages.pt, aiServicesMessages.pt, professionDescriptions.pt),
    cs: merge(cs, onboardingMessages.cs, aiServicesMessages.cs, professionDescriptions.cs),
}
